import * as THREE from 'three';

/**
 * Returns an array of projected points on a mesh from an array of input points.
 *
 * @param {THREE.Vector3[]} points - An array of input points to project onto the mesh.
 * @param {THREE.Mesh} mesh - The mesh to project the points onto.
 * @returns {THREE.Vector3[]} An array of projected points on the mesh.
 */
export const projectPointsToMesh = (points, mesh) => {
  const raycaster = new THREE.Raycaster();
  const projectedPoints = [];
  
  for (let i=0; i<points.length; i++) {
    const point = points[i];
    const direction = new THREE.Vector3(0, 1, 0);
    raycaster.set(point, direction);
    const intersects = raycaster.intersectObject(mesh);
    if (intersects.length > 0) {
      projectedPoints.push(intersects[0].point);
    }
  }
  return projectedPoints;
}


/**
 * Calculates the intersection between two surface geometries.
 * 
 * @param {THREE.BufferGeometry} targetSurfaceGeometry - The geometry of the target surface.
 * @param {THREE.BufferGeometry} trimSurfaceGeometry - The geometry of the trim surface.
 * @returns {Array} - An array containing the intersection points, face indices, and vertex indices.
 */
export const surfaceSurfaceIntersection = (targetSurfaceGeometry, trimSurfaceGeometry) => {
  // judege index or non-index
  if (targetSurfaceGeometry.index === null) {
    console.log("Target surface is non-indexed.");
    // TODO: add convert function from non-index to index
  } else {
    // console.log("Target surface is indexed.");
  }

  if (trimSurfaceGeometry.index === null) {
    console.log("Trim surface is non-indexed.");
    // TODO: add convert function from non-index to index
  } else {
    // console.log("Trim surface is indexed.");
  }

  // convert trimSurfaceGeometry to object3d
  const trimSurfaceObject = new THREE.Object3D();
  trimSurfaceObject.add(new THREE.Mesh(trimSurfaceGeometry));

  const intersections = [];
  const intersectionFaceIndices = [];
  const intersectionFaceVertexIndices = [];
  const raycaster = new THREE.Raycaster();
  
  // get target surface vertices
  const vertices = targetSurfaceGeometry.attributes.position.array;
  const faces = targetSurfaceGeometry.index.array;

  // perform a ray cast for each side of the triangle
  for (let i = 0; i < faces.length; i += 3) {
    const a = new THREE.Vector3(vertices[faces[i] * 3], vertices[faces[i] * 3 + 1], vertices[faces[i] * 3 + 2]);
    const b = new THREE.Vector3(vertices[faces[i + 1] * 3], vertices[faces[i + 1] * 3 + 1], vertices[faces[i + 1] * 3 + 2]);
    const c = new THREE.Vector3(vertices[faces[i + 2] * 3], vertices[faces[i + 2] * 3 + 1], vertices[faces[i + 2] * 3 + 2]);

    // perform a ray cast for each side of the triangle
    [a, b, c].forEach((vertex, index) => {
      const nextIndex = index === 2 ? 0 : index + 1;
      const nextVertex = [a, b, c][nextIndex];
      // calculate direction of the ray
      const direction = nextVertex.clone().sub(vertex).normalize();
      // raycaster setting
      raycaster.set(vertex, direction);
      const rayLength = vertex.distanceTo(nextVertex);
      raycaster.far = rayLength;
      
      // get intersection points
      const intersects = raycaster.intersectObject(trimSurfaceObject);
      if (intersects.length > 0 && intersects[0].distance < rayLength) {
        intersections.push(intersects[0].point);
        intersectionFaceIndices.push(intersects[0].faceIndex);
        intersectionFaceVertexIndices.push([intersects[0].face.a, intersects[0].face.b, intersects[0].face.c]);
      }
    });
  }

  return [intersections, intersectionFaceIndices, intersectionFaceVertexIndices];
}